/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class NotificationPolicyConfigSplunk {
  /**
  * The authentication token for splunk API
  */
  'token'?: string;
  /**
  * The URL of the splunk HEC endpoint
  */
  'url'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "token",
      "baseName": "token",
      "type": "string",
      "format": ""
    },
    {
      "name": "url",
      "baseName": "url",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotificationPolicyConfigSplunk.attributeTypeMap;
  }

  public constructor() {
  }
}

